// extracted by mini-css-extract-plugin
export default {"price":"k8-z","priceRow":"l8-z","onSale":"m8-z","msrpLabelPrice":"n8-z","msrpLabel":"o8-z","originalPrice":"p8-z","percentOff":"q8-z"};